(function () {
    const overlay = document.querySelector('.product-benefit__popup-overlay');
    const triggers = document.querySelectorAll('.product-benefit__trigger');
    const closeBtn = overlay?.querySelector('.product-benefit__popup-close');

    triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            overlay?.classList.add('active');
            document.body.style.overflow = 'hidden';
        });
    });

    closeBtn?.addEventListener('click', function () {
        overlay?.classList.remove('active');
        document.body.style.overflow = '';
    });

    overlay?.addEventListener('click', function (e) {
        if (e.target === overlay) {
            overlay.classList.remove('active');
            document.body.style.overflow = '';
        }
    });
})();